















import { computed, defineComponent, ref, watch } from "@vue/composition-api";
import OccRadio from "@/components/Atoms/OccRadio/index.vue";
import OccButton from "@/components/Atoms/OccButton/index.vue";
import OccHeading from "@/components/Atoms/OccHeading/index.vue";

const FOOTER_HEIGHT = {
  close: 0,
  open: 80
} as const;

export default defineComponent({
  name: "FixedFooter",
  props: {
    selectedCount: {
      type: Number,
      default: 0
    },
    totalCount: {
      type: Number,
      default: 0
    }
  },
  components: { OccRadio, OccButton, OccHeading },
  setup(props) {
    const selectedItemIndex = ref<number>(-1);

    const onChange = (index: number) => {
      selectedItemIndex.value = index;
    };

    const resetSelect = () => {
      selectedItemIndex.value = -1;
    };

    const isChecked = (index: number) => {
      return selectedItemIndex.value === index;
    };

    const fixedFooterStyle = computed(() =>
      props.selectedCount > 0
        ? `height: ${FOOTER_HEIGHT.open}px`
        : `height: ${FOOTER_HEIGHT.close}px`
    );

    watch(
      () => props.selectedCount,
      val => {
        if (val === 0) {
          resetSelect();
        }
      }
    );

    return {
      onChange,
      isChecked,
      selectedItemIndex,
      fixedFooterStyle
    };
  }
});
